<template>
  <v-autocomplete
    color="primary"
    v-model="materialsSelected"
    :clearable="!unclearable"
    :items="materialsItems"
    :loading="materialsLoading"
    :search-input.sync="materialsSearch"
    item-value="material_id"
    item-text="Description"
    item-disabled="disabled"
    :label="noLabel ? '' : label?label:$t('Material.title')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    chips
    multiple
    deletable-chips
    small-chips
  >
  </v-autocomplete>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import StockMaterials from "@/api/stock_materials";

export default {
  name: "SearcherStockMaterials",

  props: {
    stockId: Number,
    value: Array,
    noLabel: Boolean,
    label: String,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
  },

  computed: {
    materialsItems() {
      return this.materials.map((material) => {
        const Description = this.dense
          ? material.material_name
          : i18n.t("Material.materialNameWithCodeAndStandard", [
              material.material_code,
              material.material_name,
              material.standard_name ? (material.standard_name.length > 12 ? material.standard_name.slice(0, 12) + "......" : material.standard_name) : "",
            ]);
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.material_id == material.material_id
            )
          : false;
        return Object.assign({}, material, { Description, disabled });
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    materials: [],
    materialsLoading: false,
    materialsSearch: "",
    materialsSelected: null,
  }),

  methods: {
    getMaterialsFromAPI() {
      this.materialsLoading = true;
      StockMaterials.fetchAll({ stock_id: this.stockId, readonly: 0 })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materials = response.data.materials;
            }
            this.materialsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.materialsLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.materialsSelected = this.value;
      },
    },
    materialsSelected: {
      handler() {
          this.$emit("input", this.materialsSelected);
      },
    },
    stockId: {
      immediate: true, //初始赋值也调用
      handler() {
        if (typeof this.stockId != "undefined" && this.stockId != null)
          this.getMaterialsFromAPI();
      },
    },
  },
};
</script>
